// extracted by mini-css-extract-plugin
export default {"root":"_2R7PI","label":"_14Njs","value":"_21sAC"};